import { Card, Divider, Header, Icon, Segment } from "semantic-ui-react";

interface Props {
  permitHasBoundaries: boolean;
  onPermitBoundariesClick?: () => void;
}

const PermitMap = ({ permitHasBoundaries, onPermitBoundariesClick }: Props) => {
  return (
    <Segment basic vertical>
      <Header as="h3">
        <Icon name="map" />
        <Header.Content>Map</Header.Content>
      </Header>
      <Divider />
      {permitHasBoundaries && (
        <Card
          content
          style={{ "box-shadow": "0px 0px", backgroundColor: "transparent" }}
          onClick={onPermitBoundariesClick}
        >
          <Card.Content style={{ padding: "0px", margin: "0px" }}>Permit boundaries</Card.Content>
        </Card>
      )}
    </Segment>
  );
};

export default PermitMap;
